// extracted by mini-css-extract-plugin
export var date = "screen1-module--date--b5d8a";
export var dateWrap = "screen1-module--date-wrap--75373";
export var info = "screen1-module--info--be7f9";
export var screen1 = "screen1-module--screen1--3e36e";
export var type = "screen1-module--type--1dc33";